import i18n from "../../../../i18n";

export const NEW_AREA = [{
  type: 'text',
  label: i18n.t('Area name'),
  path: 'name',
  text: i18n.t('This is a custom name field, it serves the purpose to remind you what this area is about.')
}, {
  type: 'text',
  label: i18n.t('Area description'),
  path: 'description',
  text: i18n.t('This is a custom description field, it serves the purpose to remind you what this area is about.')
}, {
  type: 'tag',
  label: i18n.t('Fleet'),
  header: i18n.t('Fleets monitoring this area'),
  path: 'fleets',
  options: 'fleets',
  text: i18n.t('Set which fleet nees to be monitored in this specific area.')
}]
